var get_chat = function (version) {
  this.get_scripts = function () {
    var urls = {
      vendor: '//chat.bookingflix.com/chunk-vendors.js',
      app: '//chat.bookingflix.com/app.js',
      css: '//chat.bookingflix.com/app.css'
    }

    var script = document.createElement('script')
    script.setAttribute('src', urls.vendor + '?v=' + version)

    if (!this.isLoaded(urls.vendor)) { document.head.appendChild(script) }

    var css = document.createElement('link')
    css.setAttribute('rel', 'stylesheet')
    css.setAttribute('href', urls.css + '?v=' + version)

    if (!this.isLoaded(urls.css)) { document.head.appendChild(css) }

    var script = document.createElement('script')
    script.setAttribute('src', urls.app + '?v=' + version)

    if (!this.isLoaded(urls.app, true)) { document.body.appendChild(script) }
  }

  this.isLoaded = function (url, forceReload) {
    var scripts = document.getElementsByTagName('script')
    for (var i = scripts.length; i--;) {
      if (scripts[i].src.indexOf(url) != -1) {
        if (typeof forceReload === 'boolean' && forceReload) {
          scripts[i].remove()
          return false
        }

        return true
      }
    }
    return false
  }
}

export {get_chat}
